import { LoanType, LoanTypeOptions } from '../LoanConstants';

export const getLoanTypeName = (typeId: LoanType) => {
    const item = LoanTypeOptions.find((a) => {
        return a.id === typeId;
    });
    return item?.name ?? '';
};
